// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  DropupWrapper: styled.div`
    position: relative;
  `,
  DropupButton: styled.div`
    font: 20px Noto Sans TC;
    cursor: pointer;
  `,
  DropupContainer: styled.div`
    display: flex;
    flex-direction: column;
    width: 103px;
    position: absolute;
    bottom: 42px;
    right: -5px;
  `,
  DropupOption: styled.div<{ isUsed:boolean }>`
    font: 18px Noto Sans TC;
    color: ${props => props.isUsed ? '#434343' : '#FFF'};
    background-color: ${props => props.isUsed? '#DEDEDE' : '#434343'};
    padding: 0px 8px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: ${props => props.isUsed ? 'space-between' : 'flex-end'};
    cursor: pointer;

    ${props => props.isUsed && `
    &::before {
      content: '';
      height: 8px;
      width: 8px;
      border-radius: 100%;
      background: #434343;
      display: block;
    }`}
  `,
  DropupCustomButtonWrapper: styled.div``
}
